module.exports = __webpack_public_path__ + "static/media/opakowania_5_A.02bc6f8d.png";